import React, { Component } from 'react';
import creditCards from '../../images/credit-cards.png';
import spinner from '../../images/loading-spinner.gif';
import { translate } from 'react-i18next';

class Payment extends Component {
    render() {
        const tab = '\u00A0';
        const { t } = this.props;
        const promoCode = this.props.promoCode
        const Isdisabled = (!this.props.cardName || !this.props.cardNumber ||
            !this.props.cardMonth || !this.props.cardYear ||
            !this.props.cardCvc || !this.props.street ||
            !this.props.neighborhood || !this.props.po ||
            !this.props.city || !this.props.state) || this.props.Isdisabled
        return (
            <div className="jumbotron panel-benefits panel-summit">
                <div className="row">
                    <div className="col-md-12">
                        <form method="post" onSubmit={this.props.handlePaymentSubmit}>
                            <fieldset>
                                <div className="form-group">
                                    <h2 className="form-group-title">Datos de Pago</h2>
                                </div>
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handleCardName}
                                            placeholder={t('dashboard.room_payment.holder_cname')}
                                            type="text"
                                            value={this.props.cardName} />
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            maxLength="16"
                                            onChange={this.props.handleCardNumber}
                                            placeholder={t('dashboard.room_payment.holder_cnumber')}
                                            type="text"
                                            value={this.props.cardNumber} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            max="12"
                                            min="1"
                                            onChange={this.props.handleCardMonth}
                                            placeholder={t('dashboard.room_payment.holder_cmonth')}
                                            type="number"
                                            value={this.props.cardMonth} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            max="99"
                                            min="19"
                                            onChange={this.props.handleCardYear}
                                            placeholder={t('dashboard.room_payment.holder_cyear')}
                                            type="number"
                                            value={this.props.cardYear} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            maxLength="4"
                                            onChange={this.props.handleCardCvc}
                                            placeholder={t('dashboard.room_payment.holder_cvc')}
                                            type="number"
                                            value={this.props.cardCvc} />
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <p>
                                        <small className="text-muted">
                                            {t('dashboard.room_payment.security')}
                                        </small>
                                    </p>
                                </div>
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handleStreetChange}
                                            placeholder={t('dashboard.room_payment.holder_street')}
                                            type="text"
                                            value={this.props.street} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handleNeighborhoodChange}
                                            placeholder={t('dashboard.room_payment.holder_neighborhood')}
                                            type="text"
                                            value={this.props.neighborhood} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handlePoChange}
                                            placeholder={t('dashboard.room_payment.holder_po')}
                                            type="number"
                                            value={this.props.po} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handleCityChange}
                                            placeholder={t('dashboard.room_payment.holder_city')}
                                            type="text"
                                            value={this.props.city} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handleStateChange}
                                            placeholder={t('dashboard.room_payment.holder_state')}
                                            type="text"
                                            value={this.props.state} />
                                    </div>
                                </div>
                                {/* <div className="col-xs-12 col-sm-4">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handleCountryChange}
                                            placeholder={t('dashboard.room_payment.holder_country')}
                                            type="text"
                                            value={this.props.country} />
                                    </div>
                                </div> */}
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <div className="checkbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    value="" />
                                                {t('dashboard.room_payment.terms')}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className={this.props.error ? "" : "hidden"}>
                                        <div className="alert alert-warning">
                                            <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                                            {this.props.error}
                                        </div>
                                    </div>
                                </div>
                                <div className="data_info_page_promocode">
                                    <div className="data_info_page_promocode_center">
                                        {this.props.porcentaje_summit
                                            ? (
                                                <div>
                                                    <p style={{ textAlign: "center" }}>Porcentaje de Descuento:  {this.props.porcentaje_summit}%</p>
                                                </div>
                                            )
                                            : null
                                        }
                                        {this.props.porcentaje_summit
                                            ? (
                                                <div>
                                                    <p style={{ textAlign: "center" }}>Descuento: {((this.props.porcentaje_summit / 100) * 1990).toFixed(2)}MXN</p>
                                                </div>
                                            )
                                            : null
                                        }
                                        {this.props.porcentaje_summit
                                            ? (
                                                <div>
                                                    <p style={{ textAlign: "center" }}>Total: {((1 - (this.props.porcentaje_summit / 100)) * 1990).toFixed(2)}MXN</p>
                                                </div>
                                            )
                                            : (
                                                <div>
                                                    <p style={{ textAlign: "center" }}>Total: 1990 MXN</p>
                                                </div>
                                            )}
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <div className="form-group-button">
                                            <button
                                                className="btn btn-primary btn-resvations col-md-6 btn-paysummit"
                                                onClick={this.props.handleReturn}
                                                type="button">
                                                <i className="fa fa-arrow-left" aria-hidden="true" />
                                                &emsp;Atrás
                                            </button>
                                            <button
                                                className="btn btn-primary btn-resvations col-md-6 btn-returnsummit"
                                                type="submit"
                                                disabled={Isdisabled}>
                                                {!this.props.isPaying ? (
                                                    <div>
                                                        <i className="fa fa-shopping-cart" aria-hidden="true" />
                                                        {tab}{t('dashboard.room_payment.btn_pay')}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <img
                                                            width="45px"
                                                            alt={t('dashboard.room_payment.img_spinner')}
                                                            src={spinner} />
                                                        {tab}PROCESANDO PAGO
                                                    </div>
                                                )}

                                            </button>

                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-xs-12 col-sm-6 text-right">
                                    <img alt={t('dashboard.room_payment.img_credit')} width="150px" src={creditCards} />
                                </div> */}
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(Payment);



// WEBPACK FOOTER //
// ./src/guest/summit/Payment.js